import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-dbbdb97e")

_pushScopeId("data-v-dbbdb97e")
const _hoisted_1 = { class: "headTip" }
const _hoisted_2 = { class: "topText" }
const _hoisted_3 = { class: "topText_flex" }
const _hoisted_4 = { class: "carBrand" }
const _hoisted_5 = {
  key: 0,
  class: "brandlogo_wrapper"
}
const _hoisted_6 = { class: "topText_one" }
const _hoisted_7 = { class: "topTags" }
const _hoisted_8 = {
  key: 0,
  class: ""
}
const _hoisted_9 = { class: "productname_wrapper productname_bg" }
const _hoisted_10 = {
  key: 1,
  class: "topText_xny pl6"
}
const _hoisted_11 = { class: "topText_small" }
const _hoisted_12 = /*#__PURE__*/_createVNode("div", { class: "topText_small_shallow" }, "The vehicle models are for reference only.", -1)
const _hoisted_13 = { class: "" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_nevsCard = _resolveComponent("nevsCard")

  return (_openBlock(), _createBlock("div", null, [
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _createVNode("div", _hoisted_3, [
          _createVNode("div", _hoisted_4, [
            (_ctx.getData('brandLogo'))
              ? (_openBlock(), _createBlock("div", _hoisted_5, [
                  _createVNode("img", {
                    src: _ctx.getData('brandLogo'),
                    class: "topText_brandlogo"
                  }, null, 8, ["src"])
                ]))
              : _createCommentVNode("", true),
            _createVNode("div", _hoisted_6, _toDisplayString(_ctx.getData("brandSeriesName")), 1)
          ]),
          _createVNode("div", _hoisted_7, [
            (_ctx.getData('detectItem'))
              ? (_openBlock(), _createBlock("div", _hoisted_8, [
                  _createVNode("div", _hoisted_9, [
                    _createVNode("span", {
                      class: "productname_font",
                      text: _ctx.getData('detectItem')
                    }, _toDisplayString(_ctx.getData("detectItem")), 9, ["text"])
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.getData('energyType') === '2')
              ? (_openBlock(), _createBlock("div", _hoisted_10, [
                  _createVNode("img", {
                    src: require('../../../../../assets/batteryFrame/nevsLogoEn.png'),
                    alt: ""
                  }, null, 8, ["src"])
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        _createVNode("div", _hoisted_11, "VIN: " + _toDisplayString(_ctx.getData("VIN")), 1),
        _hoisted_12
      ]),
      _createVNode("div", _hoisted_13, [
        _createVNode(_component_nevsCard, { renderData: _ctx.renderData }, null, 8, ["renderData"])
      ])
    ])
  ]))
})